import { doc, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Studio } from "../types";

export const getStudioDetails = async (studioId: string): Promise<Studio> => {
  const docRef = doc(db, "studios", studioId);

  const studioSnapshot = await getDoc(docRef);

  return studioSnapshot.data() as Studio;
};
